// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-container[data-v-6065a6ca]{display:flex;position:relative;justify-content:center;align-items:center;overflow:hidden}.spinner-modal[data-v-6065a6ca]{z-index:50}.spinner-modal .animation-content.modal-content[data-v-6065a6ca]{overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
